exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emailPreviewCont{background-color:#fafafa;padding:20px;border:1px solid #eaeaea;border-radius:6px}.emailPreviewCont .form-group{padding-left:130px;position:relative;margin-bottom:10px}.emailPreviewCont .form-group label{position:absolute;left:0;color:#7f7f7f;font-weight:400}.emailPreviewCont .form-group p{color:#414141;font-size:14px;word-wrap:break-word}.emailPreviewCont .form-group p span.emailId{color:#ffffff;background:#265390;font-size:13px;padding:2px 10px;border-radius:4px;margin-bottom:5px;display:inline-block}h6{font-size:14px;color:#265390;font-weight:600}h6 span{vertical-align:middle}h6 span.icon{margin-right:5px}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/output/mail/mail-preview/mail-preview.component.scss
// module id = 1371
// module chunks = 1